export const FOCUS_TYPES = [
    { value: 'amount', label: 'Сумма' },
    { value: 'count', label: 'Количество' },
];
